import React from 'react';
import TeamTableList from '../components/TeamTableList';
import PageLayout from '../components/layout/PageLayout';

const TeamsListPage = () => (
  <PageLayout>
    <TeamTableList />
  </PageLayout>
);

export default TeamsListPage;